import React, { useState, useEffect } from "react";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Input,
    Table,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Spinner,
    Pagination,
    CardFooter
} from "reactstrap";
import { toast } from 'react-toastify';
import { FaEye, FaPencilAlt, FaTrash, FaPlus, FaFilePdf, FaPrint } from 'react-icons/fa';
import { apiURL } from '../../config';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ReactPaginate from 'react-paginate';
import axios from 'axios';

const CustomTable = ({ columns, data }) => {
    // console.log('ORG NAME DATA WILL IN IT for ', ' is ', columns)
    return (
        <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
                <tr className="table-row-h">
                    {columns?.map((column, idx) => (
                        <th scope="col" key={idx}>
                            {column}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data?.map((row, index) => {
                    const valuePair = Object?.values(row);
                    return (
                        <tr key={index}>
                            {valuePair?.map((value, idx) => (
                                <td key={idx}>{value}</td>
                            ))}
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

const DonorInformation = () => {
    const token = localStorage.getItem("token");

    const [donors, setDonors] = useState([]);
    const [newDonor, setNewDonor] = useState({
        name: "",
        email: "",
        phone: "",
        address: "",
        type: "individual",
        anonymityPreference: false,
        notes: "",
        orgName: ""

    });
    const [editDonor, setEditDonor] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [viewDonor, setViewDonor] = useState(null);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteDonorId, setDeleteDonorId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 10;
    const baseURL = apiURL;
    const [loading, setLoading] = useState(false);
    const [madrasaInfo, setMadrasaInfo] = useState({});

    useEffect(() => {
        fetchDonors();
        fetchMadrasaInfo();
    }, [currentPage]);

    const fetchMadrasaInfo = async () => {
        try {
            const response = await axios.get(`${baseURL}/superadmin/school-settings`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            const data = response.data;
            if (data && data.length > 0) {
                setMadrasaInfo(data[0]);
            }
        } catch (error) {
            console.error('Error fetching madrasa info:', error);
        }
    };

    const fetchDonors = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${baseURL}/superadmin/donors?page=${currentPage}&limit=${itemsPerPage}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            const data = response.data;
            if (data && data.donors && Array.isArray(data.donors)) {
                // console.log('data.donors is ', data.donors)
                setDonors(data.donors);
                setTotalPages(data.totalPages);
            } else {
                setDonors([]);
                setTotalPages(1);
            }
        } catch (error) {
            // console.error('Error fetching donors:', error);
            toast.error('Error fetching donors!');
        } finally {
            setLoading(false);
        }
    };

    const handleAddDonor = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${baseURL}/superadmin/donors`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(newDonor),
            });
            if (response.ok) {
                toast.success("Donor added successfully!");
                fetchDonors();
                setNewDonor({
                    name: "",
                    email: "",
                    phone: "",
                    address: "",
                    type: "individual",
                    anonymityPreference: false,
                    notes: "",
                    orgName: ""

                });
                setModalOpen(false);
            } else {
                toast.error("Error adding donor!");
            }
        } catch (error) {
            console.error("Error adding donor:", error);
            toast.error("Error adding donor!");
        }
    };

    const handleEditDonor = (donor) => {
        setEditDonor(donor);
        setEditModalOpen(true);
    };

    const handleUpdateDonor = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${baseURL}/superadmin/donors/${editDonor._id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(editDonor),
            });
            if (response.ok) {
                toast.success("Donor updated successfully!");
                fetchDonors();
                setEditDonor(null);
                setEditModalOpen(false);
            } else {
                toast.error("Error updating donor!");
            }
        } catch (error) {
            console.error("Error updating donor:", error);
            toast.error("Error updating donor!");
        }
    };

    const handleDeleteDonor = (id) => {
        setDeleteDonorId(id);
        setDeleteModalOpen(true);
    };

    const confirmDeleteDonor = async () => {
        try {
            const response = await fetch(`${baseURL}/superadmin/donors/${deleteDonorId}`, {
                method: "DELETE",
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            if (response.ok) {
                toast.success("Donor deleted successfully!");
                fetchDonors();
            } else {
                toast.error("Error deleting donor!");
            }
        } catch (error) {
            console.error("Error deleting donor:", error);
            toast.error("Error deleting donor!");
        } finally {
            setDeleteModalOpen(false);
            setDeleteDonorId(null);
        }
    };

    const handleViewDonor = (donor) => {
        setViewDonor(donor);
        setViewModalOpen(true);
    };

    const filteredDonors = React.useMemo(() => {
        return donors ? donors.filter(donor => {
            const nameMatch = donor.name.toLowerCase().includes(searchQuery.toLowerCase());
            return nameMatch;
        }) : [];
    }, [donors, searchQuery]);

    const handlePageChange = (selectedPage) => {
        setCurrentPage(selectedPage.selected + 1);
    };

    const anonymize = (value) => {
        return value ? 'x'.repeat(10) : value;
    };

    const generateReport = () => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();

        // School Logo and Information (Header)
        const img = new Image();
        img.src = "https://res.cloudinary.com/djg7v9dna/image/upload/v1742946371/mi0wavjsehps20kdzaet.png";

        doc.addImage(img, 'PNG', 15, 15, 30, 30);

        doc.setFontSize(16);
        doc.setFont('helvetica', 'bold');
        doc.text(madrasaInfo.schoolName || 'Madrasa Name', 50, 22);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.text(madrasaInfo.schoolAddress || 'Madrasa Address', 50, 28);
        doc.text(`Tel: ${madrasaInfo.schoolPhoneNumber || 'Phone'} | Email: ${madrasaInfo.schoolEmail || 'Email'}`, 50, 34);

        // Report Title
        doc.setFontSize(18);
        doc.text('Donor Information Report', pageWidth / 2, 55, { align: 'center' });

        // Define the columns for the table
        const columns = ["Name", "Email", "Phone", "Address", "Type", "Organization Name"];

        // Prepare the data for the table
        const data = filteredDonors ? filteredDonors.map(donor => [
            donor.name,
            donor.email,
            donor.phone,
            donor.address,
            donor.type,
            donor.orgName || '-'
        ]) : [];

        // Add the table to the PDF
        doc.autoTable({
            startY: 65,
            head: [columns],
            body: data,
            margin: { left: 15, right: 15 },
        });

        // Footer
        const totalPages = doc.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.setTextColor(0, 0, 0);
            doc.text(`Generated on: ${new Date().toLocaleDateString()} | ${madrasaInfo.schoolName || 'Madrasa Name'}`,
                pageWidth - 40, doc.internal.pageSize.getHeight() - 10);
        }

        // Save the PDF
        doc.save('donors_report.pdf');
    };

    const printDonor = (donor) => {
        const printContent = `
            <html>
            <head>
                <title>Donor Information</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; }
                    .header { text-align: center; margin-bottom: 20px; }
                    .school-name { font-size: 24px; font-weight: bold; }
                    .school-info { font-size: 14px; }
                    .donor-title { font-size: 20px; margin-bottom: 10px; }
                    .donor-details { margin-top: 20px; }
                    .footer { text-align: center; margin-top: 20px; font-size: 12px; }
                </style>
            </head>
            <body>
                <div class="header">
                    <img src="https://res.cloudinary.com/djg7v9dna/image/upload/v1739198257/Logo/kgamz0yjfr9uy8dsbnur.webp" alt="Madrasa Logo" width="100"/>
                    <div class="school-name">${madrasaInfo.schoolName || 'Madrasa Name'}</div>
                    <div class="school-info">
                        ${madrasaInfo.schoolAddress || 'Madrasa Address'}<br/>
                        Tel: ${madrasaInfo.schoolPhoneNumber || 'Phone'} | Email: ${madrasaInfo.schoolEmail || 'Email'}
                    </div>
                </div>
                <div class="donor-title">Donor Information</div>
                <div class="donor-details">
                    <div><strong>Name:</strong> ${donor.name}</div>
                    <div><strong>Email:</strong> ${donor.email}</div>
                    <div><strong>Phone:</strong> ${donor.phone}</div>
                    <div><strong>Address:</strong> ${donor.address}</div>
                    <div><strong>Type:</strong> ${donor.type}</div>
                    ${donor.type === 'organization' ? `<div><strong>Organization Name:</strong> ${donor.orgName}</div>` : ''}
                    <div><strong>Anonymity Preference:</strong> ${donor.anonymityPreference ? "Yes" : "No"}</div>
                    <div><strong>Notes:</strong> ${donor.notes}</div>
                </div>
                <div class="footer">Generated on: ${new Date().toLocaleDateString()}</div>
            </body>
            </html>
        `;

        const printWindow = window.open('', '', 'width=600,height=600');
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.print();
    };

    const columns = [
        "Name",
        "Email",
        "Phone",
        "Address",
        "Type",
        "Organization Name",
        "Actions",
    ];

    const rows = filteredDonors ? filteredDonors.map((donor) => ({
        name: donor.anonymityPreference ? anonymize(donor.name) : donor.name,
        email: donor.anonymityPreference ? anonymize(donor.email) : donor.email,
        phone: donor.anonymityPreference ? anonymize(donor.phone) : donor.phone,
        address: donor.anonymityPreference ? anonymize(donor.address) : donor.address,
        type: donor.type,
        orgName: donor.type === "organization" ? donor.anonymityPreference ? anonymize(donor.orgName) : donor.orgName : '-',
        actions: (
            <div className="d-flex">
                <Button
                    color="info"
                    size="sm"
                    onClick={() => handleViewDonor(donor)}
                >
                    <FaEye />
                </Button>
                <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleEditDonor(donor)}
                >
                    <FaPencilAlt />
                </Button>
                <Button
                    color="danger"
                    size="sm"
                    onClick={() => handleDeleteDonor(donor._id)}
                >
                    <FaTrash />
                </Button>
                <Button
                    color="secondary"
                    size="sm"
                    onClick={() => printDonor(donor)}
                >
                    <FaPrint />
                </Button>
            </div>
        ),
    })) : [];

    return (
        <>
            <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0">Donor Information</h3>
                    <div>
                        <Input
                            type="text"
                            placeholder="Search donors..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{ marginRight: '10px', display: 'inline-block', width: '200px' }}
                        />
                        <Button color="primary" onClick={() => setModalOpen(true)} style={{ marginRight: '10px' }}>
                            <FaPlus /> Add New
                        </Button>
                        <Button color="primary" onClick={generateReport}>
                            <FaFilePdf /> Generate Report
                        </Button>
                    </div>
                </CardHeader>
                <CardBody>
                    {loading ? (
                        <Spinner />
                    ) : (
                        <CustomTable
                            columns={columns}
                            data={rows}
                        />
                    )}
                </CardBody>
                <CardFooter className="py-4">
                    <nav aria-label="...">
                        <Pagination
                            className="pagination justify-content-end mb-0"
                            listClassName="justify-content-end mb-0"
                        >
                            <ReactPaginate
                                previousLabel={
                                    <i
                                        className="previous fa fa-chevron-left"
                                        aria-hidden="true"
                                    ></i>
                                }
                                nextLabel={
                                    <i
                                        className="next fa fa-chevron-right"
                                        aria-hidden="true"
                                    ></i>
                                }
                                breakLabel={"..."}
                                pageCount={totalPages}
                                onPageChange={handlePageChange}
                                containerClassName={"pagination justify-content-end mb-0"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                activeClassName={"active"}
                                previousClassName={"page-item"}
                                nextClassName={"page-item"}
                                previousLinkClassName={"page-link"}
                                nextLinkClassName={"page-link"}
                            />
                        </Pagination>
                    </nav>
                </CardFooter>
            </Card>
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
                <ModalHeader toggle={() => setModalOpen(false)}>Add New Donor</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleAddDonor}>
                        <FormGroup>
                            <Label>Name</Label>
                            <Input
                                type="text"
                                placeholder="Enter donor name"
                                value={newDonor.name}
                                onChange={(e) => setNewDonor({ ...newDonor, name: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Email</Label>
                            <Input
                                type="email"
                                placeholder="Enter donor email"
                                value={newDonor.email}
                                onChange={(e) => setNewDonor({ ...newDonor, email: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Phone</Label>
                            <Input
                                type="text"
                                placeholder="Enter donor phone"
                                value={newDonor.phone}
                                onChange={(e) => setNewDonor({ ...newDonor, phone: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Address</Label>
                            <Input
                                type="text"
                                placeholder="Enter donor address"
                                value={newDonor.address}
                                onChange={(e) => setNewDonor({ ...newDonor, address: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Type</Label>
                            <Input
                                type="select"
                                value={newDonor.type}
                                onChange={(e) => setNewDonor({ ...newDonor, type: e.target.value })}
                            >
                                <option value="individual">Individual</option>
                                <option value="organization">Organization</option>
                            </Input>
                        </FormGroup>
                        {newDonor.type === 'organization' &&
                            <FormGroup>
                                <Label>Organization Name</Label>
                                <Input
                                    type="text"
                                    placeholder="Enter Organization Name"
                                    value={newDonor.orgName}
                                    onChange={(e) => setNewDonor({ ...newDonor, orgName: e.target.value })}
                                />
                            </FormGroup>}

                        <FormGroup className="d-flex align-items-center">
                            <Label className="mr-2">Anonymity Preference</Label>
                            <Input

                                type="checkbox"
                                checked={newDonor.anonymityPreference}
                                onChange={(e) => setNewDonor({ ...newDonor, anonymityPreference: e.target.checked })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Notes</Label>
                            <Input
                                type="textarea"
                                placeholder="Enter notes"
                                value={newDonor.notes}
                                onChange={(e) => setNewDonor({ ...newDonor, notes: e.target.value })}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Add Donor
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(false)}>
                <ModalHeader toggle={() => setEditModalOpen(false)}>Edit Donor</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleUpdateDonor}>
                        <FormGroup>
                            <Label>Name</Label>
                            <Input
                                type="text"
                                placeholder="Enter donor name"
                                value={editDonor?.name || ""}
                                onChange={(e) => setEditDonor({ ...editDonor, name: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Email</Label>
                            <Input
                                type="email"
                                placeholder="Enter donor email"
                                value={editDonor?.email || ""}
                                onChange={(e) => setEditDonor({ ...editDonor, email: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Phone</Label>
                            <Input
                                type="text"
                                placeholder="Enter donor phone"
                                value={editDonor?.phone || ""}
                                onChange={(e) => setEditDonor({ ...editDonor, phone: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Address</Label>
                            <Input
                                type="text"
                                placeholder="Enter donor address"
                                value={editDonor?.address || ""}
                                onChange={(e) => setEditDonor({ ...editDonor, address: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Type</Label>
                            <Input
                                type="select"
                                value={editDonor?.type || "individual"}
                                onChange={(e) => setEditDonor({ ...editDonor, type: e.target.value })}
                            >
                                <option value="individual">Individual</option>
                                <option value="organization">Organization</option>
                            </Input>
                        </FormGroup>
                        {editDonor?.type === 'organization' &&
                            <FormGroup>
                                <Label>Organization Name</Label>
                                <Input
                                    type="text"
                                    placeholder="Enter organization name"
                                    value={editDonor?.orgName || ""}
                                    onChange={(e) => setEditDonor({ ...editDonor, orgName: e.target.value })}
                                />
                            </FormGroup>}
                        <FormGroup className="d-flex align-items-center">
                            <Label className="mr-2">Anonymity Preference</Label>
                            <Input
                                type="checkbox"
                                checked={editDonor?.anonymityPreference || false}
                                onChange={(e) => setEditDonor({ ...editDonor, anonymityPreference: e.target.checked })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Notes</Label>
                            <Input
                                type="textarea"
                                placeholder="Enter notes"
                                value={editDonor?.notes || ""}
                                onChange={(e) => setEditDonor({ ...editDonor, notes: e.target.value })}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Update Donor
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setEditModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={viewModalOpen} toggle={() => setViewModalOpen(false)}>
                <ModalHeader toggle={() => setViewModalOpen(false)}>Donor Details</ModalHeader>
                <ModalBody>
                    {viewDonor && (
                        <div>
                            <p><strong>Name:</strong> {viewDonor.name}</p>
                            <p><strong>Email:</strong> {viewDonor.email}</p>
                            <p><strong>Phone:</strong> {viewDonor.phone}</p>
                            <p><strong>Address:</strong> {viewDonor.address}</p>
                            <p><strong>Type:</strong> {viewDonor.type}</p>
                            <p><strong>Organization Name:</strong> {viewDonor.type === 'organization' ? viewDonor.orgName : '-'}</p>

                            <p><strong>Anonymity Preference:</strong> {viewDonor.anonymityPreference ? "Yes" : "No"}</p>
                            <p><strong>Notes:</strong> {viewDonor.notes}</p>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setViewModalOpen(false)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)}>
                <ModalHeader toggle={() => setDeleteModalOpen(false)}>Delete Donor</ModalHeader>
                <ModalBody>
                    <p>Are you sure you want to delete this donor?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={confirmDeleteDonor}>
                        Yes, Delete
                    </Button>
                    <Button color="secondary" onClick={() => setDeleteModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default DonorInformation;
